import React, { useState } from 'react';
import s from './styles.module.scss';
import LazyImage from '@/components/common/lazy-image';
import { EMPTY_IMAGE_PATH } from '@/infrastructure/const/empty-image-path';
import { Reciter } from '@/infrastructure/class/reciter';
import classNames from 'classnames';
import Link from 'next/link';
import { routes } from '@/infrastructure/const/routes';

interface IRecitersListItemProps {
  data: Reciter;
  className?: string;
}

const RecitersListItem: React.FC<IRecitersListItemProps> = (props) => {
  const { data, className = '' } = props;

  const [background] = useState<string>(
    !!data.image ? data.image.mediumUrl : EMPTY_IMAGE_PATH
  );
  const route = `${routes.reciters}/${data.slug}`;

  const listItemClassNames = classNames(s['list-item'], className);
  const arabicTextClassNames = classNames(s['title'], s['ar']);

  return (
    <Link className={listItemClassNames} href={route} prefetch={false} passHref>
      <div>
        <div className={s['image']}>
          <LazyImage
            className={s['image']}
            alt={data.slug}
            src={background}
            fill
            sizes="160px"
          />
        </div>
      </div>
      <p className={s['title']}>{data.titleEn}</p>
      <p className={arabicTextClassNames}>{data.titleAr}</p>
    </Link>
  );
};

export default RecitersListItem;
